import { memo } from 'react';
import { Link } from 'react-router-dom';

import { Checkbox, Form } from 'antd';

import messages from '../constants/messages';

function AgreementField() {
  return (
    <Form.Item
      className="mb-0"
      name="isTermsAccepted"
      valuePropName="checked"
      rules={[
        {
          validator: (_, value) => (value ? Promise.resolve() : Promise.reject(new Error(messages.AGREED_REQUIRED)))
        }
      ]}>
      <Checkbox>
        I agree to the{' '}
        <Link to="/auth/terms" target="_blank" rel="noopener noreferrer">
          Terms and Conditions,
        </Link>{' '}
        and{' '}
        <Link to="/auth/privacy" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </Link>
      </Checkbox>
    </Form.Item>
  );
}

export default memo(AgreementField);
